import { render, staticRenderFns } from "./detailDialog.vue?vue&type=template&id=c625c672&scoped=true&"
import script from "./detailDialog.vue?vue&type=script&lang=js&"
export * from "./detailDialog.vue?vue&type=script&lang=js&"
import style0 from "./detailDialog.vue?vue&type=style&index=0&id=c625c672&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c625c672",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/nisems/front/nisbos-front-admin/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c625c672')) {
      api.createRecord('c625c672', component.options)
    } else {
      api.reload('c625c672', component.options)
    }
    module.hot.accept("./detailDialog.vue?vue&type=template&id=c625c672&scoped=true&", function () {
      api.rerender('c625c672', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ls-form/components/saas/dialog/detailDialog.vue"
export default component.exports